import { BrowserRouter as Router,Route, Switch } from 'react-router-dom';
import './css/main.css'
import React,{ Component } from 'react';
import Login from './js/pages/Login';
import Main from './js/pages/Main';
import NoMatch from './js/pages/NoMatch';
import PrivateRoute from './js/components/PrivateRoute';

class App extends Component{
  render(){
    return (
        <Router>
            <Switch>
                <Route path = "/login" component = {Login}/>
                <PrivateRoute path = "/"  component = {Main}/>
                <Route path ="*" component = {NoMatch}/>
            </Switch>
      </Router>
    );
  }
}
export default App;
